<template>
  <!--发票管理-->
    <div class="content InvoiceManagement">
      <div class="layui-fluid">
        <div class="layui-row">
          <div class="layui-col-md12">
            <!--面包屑-->
            <div class="layui-row">
              <div class="layui-col-md8">
              </div>
            </div>
            <div class="layui-row" style="margin-top: 20px;">
              <div class="layui-col-md12">
                <form class="layui-form" action="">
                  <div class="layui-form-item">
                    <div class="layui-inline">
                      <label class="layui-form-label">开票状态:</label>
                      <div class="layui-input-block">
                        <select name="interest" lay-filter="aihao">
                          <option>全部</option>
                          <option value="0">已开</option>
                          <option value="0">未开</option>
                        </select>
                      </div>
                    </div>
                    <div class="layui-inline">
                      <label class="layui-form-label">订单类型:</label>
                      <div class="layui-input-block">
                        <select name="interest" lay-filter="aihao">
                          <option>全部</option>
                          <option value="0">住宿订单</option>
                           <option value="0">门票订单</option>
                        </select>
                      </div>
                    </div>
                    <div class="layui-inline">
                      <label class="layui-form-label">订单编号:</label>
                      <div class="layui-input-block">
                        <input type="text" name="title" lay-verify="title" autocomplete="off" placeholder="请输入" class="layui-input">
                      </div>
                    </div>
                    <div class="layui-inline right_btn">
                      <button class="layui-btn" data-type="reload">搜素</button>
                      <button class="layui-btn" data-type="reload">导出</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div class="layui-row">
              <table class="layui-hide" id="test"></table>
              <script type="text/html" id="barDemo">
                <a class="layui-btn layui-btn-xs" lay-event="edit" style="color: #FFFFFF;">编辑</a>
                <a class="layui-btn layui-btn-danger layui-btn-xs" lay-event="del" style="color: #FFFFFF;">删除</a>
              </script>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    import $ from 'jquery';
    export default {
        name: "InvoiceManagement",
        data(){
          return {
            msg:''
          }
        },
        methods:{
          // 公共方法
          handlePublics(){
            let _this=this;
            this.$nextTick(()=>{
              layui.use(['jquery','element','table','form'],function () {
                var $ = layui.jquery;
                var element = layui.element;
                var form = layui.form
                var table = layui.table;
                /*---------发票管理开始----------*/
                table.render({
                  elem: '#test'
                  // ,url:'/demo/table/user/'
                  ,data:[]
                  ,cellMinWidth: 100 //全局定义常规单元格的最小宽度，layui 2.2.1 新增
                  ,cols: [[
                    {field:'id', title: '交易编号'}
                    ,{field:'username', title: '登记时间',width:140}
                    ,{field:'sex', title: '联系人'}
                    ,{field:'city', title: '联系电话'}
                    ,{field:'sign', title: '抬头'} //minWidth：局部定义当前单元格的最小宽度，layui 2.2.1 新增
                    ,{field:'experience', title: '汇款人'}
                    ,{field:'score', title: '用户名称'}
                    ,{field:'classify', title: '支付金额'}
                    ,{field:'wealth', title: '开票状态'}
                    ,{field:'wealths', title: '开票信息'}
                    ,{fixed: 'right', title:'操作', toolbar: '#barDemo',width:120}
                  ]]
                });
                /*---------发票管理结束----------*/
                element.render();
                form.render();
                table.render();
              })
            })
          }
        },
        mounted() {
          // 公共方法
          this.handlePublics();
        },
        updated() {
          // 公共方法
          this.handlePublics();
        }
    }
</script>

<style scoped>
  .InvoiceManagement .layui-form-label{
    width: auto;
  }
  .InvoiceManagement .layui-input-block{
    margin-left: 90px;
  }
  .InvoiceManagement .right_btn{
    margin-top: -10px;
  }
</style>
